/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type SortByNotifica =
  (typeof SortByNotifica)[keyof typeof SortByNotifica];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SortByNotifica = {
  DATA_NOTIFICA: 'DATA_NOTIFICA',
  DATA_PRESA_VISIONE: 'DATA_PRESA_VISIONE',
  TIPO: 'TIPO',
  PRIORITA: 'PRIORITA',
  ID_ISTANZA_RIFERIMENTO: 'ID_ISTANZA_RIFERIMENTO',
  OGGETTO: 'OGGETTO',
} as const;
